import React from 'react';
import styled from 'styled-components';
import bar from './base';

const Wrapper = styled.div`
  border-radius: 2px;
  border: 1px solid #eaeaea;
  background-color: white;
  text-align: center;
  padding-top: ${props => (props.pt ? `${props.pt}px` : '6px')};
  padding-bottom: ${props => (props.pb ? `${props.pb}px` : '6px')};
  padding-left: 20px;
  padding-right: 20px;
`;

const Content = styled(bar)`
  width: ${props => (props.width ? `${props.width}px` : '80px')};
  height: ${props => (props.height ? `${props.height}px` : '13px')};
  margin: 0 auto;
`;

const ButtonSkeleton = ({ width }) => {
  return (
    <Wrapper>
      <Content width={width} />
    </Wrapper>
  );
};

export default ButtonSkeleton;
